<template lang="pug">
#notation
  .annotation(v-show='notationBoolean')
    .add.item(@click.stop='createdAnnotation')
      van-image(:src='addAanno')
      | 创建批注
      van-icon.layerright(name='arrow')
    .list.item(@click.stop='annotationListClick')
      van-image(:src='annoList')
      | 批注列表
      van-icon.layerright(name='arrow')
  .showkiss(v-show='nextShow' @click='openAdd')
    span 下一步
    van-icon(name="arrow")
  .addNotePic(v-show='addpanel')
    .mpic
      .uploadpic(v-for='(item,index) in base64List' :key='index')
        van-image(:src='item.url' alt='点击截图' @click='cutDwg(index)')
        van-icon(v-show='item.hasKss' name='close' @click='delCutPic(index)')
      .right
        van-image.annotationClose(:src="require('@/CommonDP/mongeView/appView/images/pencilClose.png')" alt='关闭' srcset='' @click.stop='closefunc')
        van-image.next(:src="require('@/CommonDP/mongeView/appView/images/next.png')" alt='下一步' srcset='' @click.stop='nextfunc')
  //- 创建批注
  notationAdd(ref="notationAdd" :type="actionData.type")
  //- 批注列表
  notationList(ref="notationList")
</template>

<script>
import iconImage from "@/CommonDP/mongeView/appView/images/icon-cutImg.png";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import common from "@/CommonDP/mongeView/appView/component/common";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import notationAdd from "@/CommonDP/mongeView/appView/question/notationAdd.vue";
import notationList from "@/CommonDP/mongeView/appView/question/notationList.vue";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { notationAdd, notationList },
  data () {
    return {
      addAanno: require("@/CommonDP/mongeView/appView/images/addAanno.png"),
      annoList: require("@/CommonDP/mongeView/appView/images/annoList.png"),
      notationBoolean: true,
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      addpanel: false,
      checkContent: '',
      autoScreenshotMd5: '',
      picList: [],
      nextShow: false
    };
  },
  computed: {
    isLoginFree() {
      return this.$route.query.isLoginFree || "";
    },
    spaceOfDwgData() {
      return JSON.parse(mongeApp.map.spaceOfDwgData);
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    }
  },
  methods: {
    // 创建批注
    createdAnnotation() {
      this.notationBoolean = false;
      this.$toast('请绘制云线');
      this.AddCloudNot();
    },
    // 添加云线
    AddCloudNot() {
      mongeApiMlib.addAnnotation("", {
        callback: (type, data) => {
          if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
            this.nextShow = true;
          } else if (type === Monge.CallbackType.DONE) {
            this.screenCaptureByBox(data);
          }
        }
      });
    },
    openAdd() {
      mongeApiMlib.annotationEnd();
      this.nextShow = false;
      this.addpanel = true;
    },
    // 截图
    async cutDwg(val) {
      const cutpic = await common.startScreenShot(this.type);
      this.getAddCutPicList(cutpic, val);
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    // 截全屏
    async screenCaptureByBox(data) {
      if (data.bbox) {
        const coordinate = JSON.stringify(data.data) || '';// 云线或锚点数据
        const dataUrl = await mongeApiMlib.mongeScreenCapture(false, this.type);
        let { isH5 } = this.$route.query || {};
        if (isH5) {
          this.finishNotationAdd(coordinate, dataUrl);
        } else {
          const autoScreenshotMd5 = await this.getFileMD5(dataUrl);
          const layoutName = this.spaceOfDwgData;
          const { fileType } = this.$route.query;
          const { fileId, fileName, fileVersion, prjId } = this.dwgdata;
          const query = { fileId, fileName, fileType, versionIds: fileVersion, prjId, source: 'sureAdd',
            picList: this.picList, autoScreenshotMd5, layoutName, coordinate };
          await mongeApiMlib.uniPostMessage(query);
        }
        await this.$nextTick();
        mongeApiMlib.annotationDeactive();
        this.addpanel = false;
        this.notationBoolean = true;
      }
    },
    // 批注列表
    annotationListClick() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        const { prjId, fileId } = this.dwgdata;
        const params = {prjId, fileId};
        this.$refs.notationList.open(params);
      } else {
        const { fileId, fileName, fileVersion, prjId } = this.dwgdata;
        const layoutName = this.spaceOfDwgData;
        const data = { fileId, fileName, fileType: 8, versionIds: fileVersion, prjId, source: 'list', layoutName };
        mongeApiMlib.uniPostMessage(data);
      }
    },
    // 删除截图
    delCutPic(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    closefunc() {
      this.addpanel = false;
      mongeApiMlib.annotationDeactive();
      this.notationBoolean = true;
    },
    // 批注截图下一步
    async nextfunc() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        this.openNotationAdd();
      } else {
        this.$toast.loading({
          message: '截图存储中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner'
        });
        this.picList = [];
        for (const index in this.base64List) {
          if (this.base64List[index].hasKss) {
            this.picList.push(await this.getFileMD5(this.base64List[index].url));
          }
        }
        await this.$nextTick();
        const layoutName = this.spaceOfDwgData;
        const { fileId, fileName, fileVersion, prjId } = this.dwgdata;
        const data = { fileId, fileName, fileType: 8, versionIds: fileVersion, prjId, source: 'add', picList: this.picList, autoScreenshotMd5: '', layoutName };
        await mongeApiMlib.uniPostMessage(data);
        this.$toast.clear();
      }
      setTimeout(() => {
        this.base64List.forEach(itm => {
          itm.url = iconImage;// 清除截图
          itm.hasKss = false;// 去掉叉号
          this.footType4 = false;// 重置选中状态
        });
        this.addpanel = false;// 关闭截图弹框
      }, 1500);
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },

    // 打开创建批注
    openNotationAdd(){
      const { fileId, fileName, fileVersion, prjId } = this.dwgdata;
      const fileList = [{ fileId, fileName, fileVersion }]; // 当前文件
      const layoutName = this.spaceOfDwgData;
      let picUrlList = [];
      this.base64List.forEach(pic => {
        if(pic.hasKss) picUrlList.push(pic.url);
      });
      const params = {prjId, fileId, fileList, layoutName, picUrlList};
      this.$refs.notationAdd.open(params);
    },
    // 完成创建批注
    finishNotationAdd(coordinate, autoScreenshotUrl){
      const params = { coordinate, autoScreenshotUrl }; // 云线和自动截图url
      this.$refs.notationAdd?.createFinish(params);
    }
  }
};
</script>

<style lang="scss" scoped>
  .annotation{
    position: absolute;
    width: calc(100% - 24px);
    height: 120px;
    margin-left: 12px;
    background: rgba(0, 0, 0, 0.68);
    bottom: 58px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    .item{
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding: 0 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #FFFFFF;
      font-size: 16px;
      .van-image {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
      .layerright{
        margin-left: auto;
      }
    }
  }
  .showkiss{
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 12px;
    height: 30px;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    border-radius: 8px;
    line-height: 30px;
    bottom: 65px;
    cursor: pointer;
    right: 10px;
    z-index: 4;
    i{
      margin-left: 6px;
      font-size: 16px;
    }
  }
  .addNotePic{
    position: absolute;
    width: 100%;
    height: 70px;
    bottom: 48px;
    background: #FFFFFF;

    .mpic{
      width: 100%;
      height: 100%;
      padding: 0 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .uploadpic {
        width: 55px;
        height: 55px;
        margin-left: 8px;
        background: rgba(85, 132, 255, 0.1);
        text-align: center;
        position: relative;

        .van-image {
          width: 100%;
          height: 100%;
          display: block;
        }

        .van-icon{
          position: absolute;
          top: 0;
          right: 0;
          font-size: 16px;
          color: #ee0404;
        }

      }

      .uploadpic:first-child{
        margin-left: 0;
      }

      .right{
        margin-left: auto;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .annotationClose {
          width: 15px;
          height: 15px;
          margin-right: 15px;
        }

        .next {
          color: #fff;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  </style>
